import { render, staticRenderFns } from "./TheTree.vue?vue&type=template&id=6a0a15a1"
import script from "./TheTree.vue?vue&type=script&lang=js"
export * from "./TheTree.vue?vue&type=script&lang=js"
import style0 from "./TheTree.vue?vue&type=style&index=0&id=6a0a15a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports